import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { postSendAudioToDevices } from '../../services/AudioAnnouncementService';
import type {
  SendAudioToDevicesRequest,
  SendAudioToDevicesResponse,
} from '../../types/AudioAnnouncement';

type Result = UseMutationResult<SendAudioToDevicesResponse, Error, SendAudioToDevicesRequest>;

function useSendAudioToDevices(
  successCb: (res: SendAudioToDevicesResponse) => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation(postSendAudioToDevices, {
    onSuccess: (data, variables) => {
      successCb(data);
      queryClient.invalidateQueries({
        queryKey: ['audio-announcement-devices', variables.fleetId, variables.audioId],
      });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useSendAudioToDevices;
